(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-background-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const backgroundVideoSections = document.querySelectorAll('.background-video');

    backgroundVideoSections.forEach((section) => {
      const isMobile = window.innerWidth <= 767;
      const desktopVideo = section.querySelector('.background-video-desktop video');
      const mobileVideo = section.querySelector('.background-video-mobile video');

      function handleVideoPlayback() {
        const isMobile = window.innerWidth <= 767;
        if (isMobile && mobileVideo) {
          desktopVideo?.pause();
          mobileVideo.play();
        } else if (desktopVideo) {
          desktopVideo.play();
          mobileVideo?.pause();
        }
      }

      handleVideoPlayback();

      if (mobileVideo) {
        window.addEventListener('resize', handleVideoPlayback);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class LoadMedia extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      const deferredMediaBtn = this.closest('.video-section').querySelector('.js-load-media');
      button.addEventListener('click', () => deferredMediaBtn.click());
    }
  }
  customElements.define('load-media', LoadMedia);

  } catch(e) { console.error(e); }
})();
})();
